import { render, staticRenderFns } from "./ChildRecord.vue?vue&type=template&id=0a3dff38&scoped=true&"
import script from "./ChildRecord.vue?vue&type=script&lang=js&"
export * from "./ChildRecord.vue?vue&type=script&lang=js&"
import style0 from "./ChildRecord.vue?vue&type=style&index=0&id=0a3dff38&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a3dff38",
  null
  
)

export default component.exports